import { Box, Typography, type SxProps, type Theme } from "@mui/material";
import { type ReactNode } from "react";
import { CALIBRATE_FONT_FAMILY_ACCENT } from "components/hoc/Theme";

interface FieldLabelProps {
  children: ReactNode;
  required?: boolean;
  htmlFor?: string;
  sx?: SxProps<Theme>;
}

export default function FieldLabel({
  children,
  required = false,
  htmlFor,
  sx,
}: FieldLabelProps) {
  return (
    <Typography
      component="label"
      htmlFor={htmlFor}
      sx={{
        display: "block",
        fontFamily: CALIBRATE_FONT_FAMILY_ACCENT,
        fontWeight: 700,
        fontSize: "1rem",
        color: "#185059",
        mb: 0.75,
        ...sx,
      }}
    >
      {children}
      {required && (
        <Box component="span" sx={{ color: "error.main", ml: 0.5 }}>
          *
        </Box>
      )}
    </Typography>
  );
}
